import { render, staticRenderFns } from "./CommonTxtImg.vue?vue&type=template&id=2ca74bd4&scoped=true"
import script from "./CommonTxtImg.vue?vue&type=script&lang=js"
export * from "./CommonTxtImg.vue?vue&type=script&lang=js"
import style0 from "./CommonTxtImg.vue?vue&type=style&index=0&id=2ca74bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca74bd4",
  null
  
)

export default component.exports